import * as ep from "../../endpoints";
import api from "@/libs/axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
function mapCampaignFormData(form) {
  var mapped = { ...form };
  if (mapped.campaign_type === 0) delete mapped.campaign_amount;
  else delete mapped.number;
  const fd = new FormData();
  for (const key in mapped) {
    if (Object.hasOwnProperty.call(mapped, key)) {
      const element = mapped[key];
      if (key === "image" && typeof element === "string") continue;
      if (key === "age_category_id" && Array.isArray(element)) {
        element.forEach((cat) => {
          fd.append("age_category_id[]", cat);
        });
      } else fd.append(key, element);
    }
  }
  if (mapped.id) fd.append("_method", "PUT");

  return fd;
}
export default {
  namespaced: true,
  state: {
    loading: false,
    working: false,
    loadingDonors: false,
    workingDonors: false,
    campaigns: [],
    donors: [],
    pagination: {},
  },
  getters: {
    campaigns(state) {
      return state.campaigns;
    },
    loading(state) {
      return state.loading;
    },
    loadingDonors(state) {
      return state.loadingDonors;
    },
    donors(state) {
      return state.donors;
    },
    pagination(state) {
      return state.pagination;
    },
    working(state) {
      return state.working;
    },
    workingDonors(state) {
      return state.workingDonors;
    },
  },
  mutations: {
    setCampaigns(state, payload) {
      state.campaigns = payload;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDonors(state, payload) {
      state.donors = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    setWorking(state, payload) {
      state.working = payload;
    },
    setLoadingDonors(state, payload) {
      state.loadingDonors = payload;
    },
    setWorkingDonors(state, payload) {
      state.workingDonors = payload;
    },
  },
  actions: {
    async getCampaigns({ commit }, payload) {
      commit("setLoading", true);
      try {
        await api
          .get(ep.CAMPAIGNS, {
            params: {
              page: payload.page,
              confirmed: payload.status,
            },
          })
          .then((res) => {
            commit("setCampaigns", res.data.data);
            commit("setPagination", res.data.pagination);
          });
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
    async createCampaign({ commit, dispatch }, { form, page }) {
      commit("setWorking", true);
      try {
        var toSend = mapCampaignFormData(form);
        const res = await api.post(ep.CAMPAIGNS, toSend);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getCampaigns", { page, status: "A" });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async updateCampaign({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        var toSend = mapCampaignFormData(payload.form);
        const res = await api.post(ep.EDIT_CAMPAIGNS(payload.form.id), toSend);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getCampaigns", { page: payload.page, status: "A" });
        return Promise.resolve();
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
        return Promise.reject();
      } finally {
        commit("setWorking", false);
      }
    },
    async deleteCampaign({ commit, dispatch }, payload) {
      commit("setWorking", true);
      try {
        const res = await api.delete(ep.EDIT_CAMPAIGNS(payload.id));

        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getCampaigns", { page: payload.page, status: "P" });
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء تنفيذ العملية",
            icon: "AlertCircleIcon",
            variant: "danger",
            timeout: 3000,
          },
        });
      } finally {
        commit("setWorking", false);
      }
    },

    async getDonors({ commit }, payload) {
      commit("setLoadingDonors", true);
      try {
        await api.get(ep.DONORS(payload.id)).then((res) => {
          commit("setDonors", res.data.data);
        });
      } catch (err) {
      } finally {
        commit("setLoadingDonors", false);
      }
    },

    async addDonors({ commit, dispatch }, { data }) {
      commit("setWorkingDonors", true);
      try {
        const res = await api.post(ep.POST_DONORS, data);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تمت الإضافة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getDonors", { id: data.campaign_id });
        dispatch("getCampaigns", {
          page: data.page,
          status: "A",
        });
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      } finally {
        commit("setWorkingDonors", false);
      }
    },

    async updateDonors({ commit, dispatch }, payload) {
      commit("setWorkingDonors", true);
      try {
        const res = await api.put(ep.DONORS(payload.id), payload.data);
        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم التعديل بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getDonors", { id: payload.data.campaign_id });
        dispatch("getCampaigns", { page: payload.page, status: "A" });
        return Promise.resolve();
      } catch (err) {
        return Promise.reject();
      } finally {
        commit("setWorkingDonors", false);
      }
    },

    async deleteDonor({ commit, dispatch }, payload) {
      commit("setWorkingDonors", true);
      try {
        const res = await api.delete(ep.DONORS(payload.id));

        if (hasError(res.status)) throw res.status;
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم الحذف بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
            timeout: 3000,
          },
        });
        dispatch("getCampaigns", { page: payload.page, status: "A" });
      } catch (err) {
      } finally {
        commit("setWorkingDonors", false);
      }
    },
  },
};
